// extracted by css-extract-rspack-plugin
export default {"section":"gQ9p31fm","title":"PdmlH5CS","podiumList":"s5vPts5o","rankList":"ovG0Hx_5","viewAll":"Sv6HIZzY"};